import { useState, useCallback } from 'react';
import { userPreferences } from '../utils/userPreferences';

interface UseFiltersReturn {
    selectedFilters: string[];
    toggleFilter: (filterId: string) => void;
    clearFilters: () => void;
    updateFilters: (filters: string[]) => void;
}

/**
 * Custom hook for managing filter state
 * Handles filter selection and persistence
 */
export function useFilters(): UseFiltersReturn {
    const [selectedFilters, setSelectedFilters] = useState<string[]>(
        userPreferences.selectedFilters
    );

    const toggleFilter = useCallback((filterId: string) => {
        setSelectedFilters(prev => {
            const newFilters = prev.includes(filterId)
                ? prev.filter(id => id !== filterId)
                : [...prev, filterId];

            // Persist to user preferences using the setter method
            userPreferences.setSelectedFilters(newFilters);

            return newFilters;
        });
    }, []);

    const clearFilters = useCallback(() => {
        setSelectedFilters([]);
        userPreferences.setSelectedFilters([]);
    }, []);

    const updateFilters = useCallback((filters: string[]) => {
        setSelectedFilters(filters);
        userPreferences.setSelectedFilters(filters);
    }, []);

    return {
        selectedFilters,
        toggleFilter,
        clearFilters,
        updateFilters,
    };
}
